import { combineReducers } from 'redux';

import {
	LOGIN_USER_REQUEST,
	LOGIN_USER_SUCCESS,
	LOGIN_USER_FAILURE,
	UPDATE_USER_REQUEST,
	UPDATE_USER_SUCCESS,
	UPDATE_USER_FAILURE,
	UPDATE_PASSWORD_REQUEST,
	UPDATE_PASSWORD_SUCCESS,
	UPDATE_PASSWORD_FAILURE,
	VALIDATE_USER_REQUEST,
	VALIDATE_USER_SUCCESS,
	VALIDATE_USER_FAILURE,
	LOGOUT_USER,
} from '../types';

const addUser = (user) => {
	const { user_email, user_first, user_last, user_login, id } = user;

	return {
		email: user_email,
		firstName: user_first,
		lastName: user_last,
		username: user_login,
		id: parseInt(id, 10),	
	}
}

const updateUser = (state, user) => {
	const { user_email, first_name, last_name } = user;

	return {
		...state,
		email: user_email,
		firstName: first_name,
		lastName: last_name,
	}
}

const user = (state = false, action) => {
	switch(action.type) {
		case LOGIN_USER_SUCCESS:
			return addUser(action.payload);

		case UPDATE_USER_SUCCESS:
			return updateUser(state, action.payload);

		case LOGOUT_USER:
			return false;

		default: 
			return state;
	}
}

const isLoggingIn = (state = false, action) => {
	switch(action.type) {
		case LOGIN_USER_REQUEST:
		 return true;

		case LOGIN_USER_SUCCESS:
		case LOGIN_USER_FAILURE:
		case LOGOUT_USER:
			return false;

		default:
			return state;
	}
}

const isValidatingUser = (state = false, action) => {
	switch(action.type) {
		case VALIDATE_USER_REQUEST:
			return true;

		case VALIDATE_USER_SUCCESS:
		case VALIDATE_USER_FAILURE:
			return false;

		default:
			return state;
	}
}

const errorMessage = (state = null, action) => {
	switch(action.type) {
		case LOGIN_USER_FAILURE:
			return action.payload;

		case LOGIN_USER_REQUEST:
		case LOGIN_USER_SUCCESS:
		case LOGOUT_USER:
			return null;

		default:
			return state;
	}
}

const updateErrorMessage = (state = null, action) => {
	switch(action.type) {
		case UPDATE_USER_FAILURE:
			return action.payload;

		case UPDATE_USER_REQUEST:
		case UPDATE_USER_SUCCESS:
		case LOGOUT_USER:
			return null;

		default:
			return state;
	}
}

const passwordErrorMessage = (state = null, action) => {
	switch(action.type) {
		case UPDATE_PASSWORD_FAILURE:
			return action.payload;

		case UPDATE_PASSWORD_REQUEST:
		case UPDATE_PASSWORD_SUCCESS:
		case LOGOUT_USER:
			return null;

		default:
			return state;
	}
}

const needsRevalidation = (state = false, action) => {
	switch(action.type) {
		case UPDATE_USER_SUCCESS:
		case UPDATE_PASSWORD_SUCCESS:
			return true;

		case 	LOGIN_USER_SUCCESS:
			return false;

		default:
			return state;
	}
}

const auth = combineReducers({
	user,
	isLoggingIn,
	isValidatingUser,
	errorMessage,
	updateErrorMessage,
	passwordErrorMessage,
	needsRevalidation,
})


export default auth;

export const isAuthenticated = (state) => !!state.user;
export const getUser = state => state.user;
export const getIsLoggingIn = (state) => state.isLoggingIn;
export const getIsValidatingUser = state => state.isValidatingUser;
export const getErrorMessage = (state) => state.errorMessage;
export const getUpdateErrorMessage = (state) => state.updateErrorMessage;
export const getPasswordErrorMessage = (state) => state.passwordErrorMessage;
export const userNeedsToRevalidate = (state) => state.needsRevalidation;


// WEBPACK FOOTER //
// ./src/store/auth/reducer.js